<div class="hero bg-base-200 px-4">
  <div class="hero-content min-xl flex-col lg:flex-row-reverse gap-10">
    <div class="text-center lg:text-left">
      <h1 class="text-4xl md:text-5xl font-bold text-primary">
        Bienvenue chez <br class="hidden md:block"> Kids Gonflables Party
      </h1>

      <p class="py-6 text-base md:text-lg text-base-content/80 max-w-3xl mx-auto lg:mx-0">
        🎉 Spécialistes de la location de châteaux gonflables pour tous vos événements festifs ! <br>
        <br>
        Que ce soit pour un anniversaire 🎂, un mariage 💍, un baptême 👶, une fête d’entreprise (CE) 🏢 ou toute autre occasion, nous vous proposons des structures sécurisées, colorées et adaptées à tous les âges !<br>
        🚛 Livraison sur toute la Grande-Terre: Nous nous déplaçons jusqu’à chez vous pour installer et récupérer le matériel.<br>
        🎪 Large choix de modèles: Vaiana, Licornes, Barbie, Robot et bien plus !<br>
        🛡️ Matériel conforme aux normes de sécurité: Nettoyé et vérifié avant chaque location.<br>
        🔑 Service clé en main: Installation, gonflage et démonstration inclus.<br>
        📲 Contactez-nous pour réserver ou obtenir un devis personnalisé !

      </p>
      <div class="flex justify-center gap-2"><button class="btn btn-primary btn-lg" routerLink="/chateaux">
        Nos châteaux
      </button>
        <button class="btn btn-primary btn-lg" routerLink="/contact">
          Nous contacter
        </button></div>

    </div>

    <div class="relative group w-full overflow-hidden rounded-box shadow-xl">

      @if (currentSlide > 0) {
        <button
          (click)="goTo(currentSlide - 1)"
          class="btn btn-circle btn-ghost absolute left-2 top-1/2 -translate-y-1/2 z-20 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity bg-base-100/50">
          ❮
        </button>
      }

      <div #carouselContainer (scroll)="onScroll()" class="carousel carousel-center w-full space-x-4 bg-neutral p-4">
        @for (photo of photos; track photo.nom) {
          <div class="carousel-item w-full md:w-1/2 lg:w-1/3">
            <img [src]="photo.photo" [alt]="'Château ' + photo.nom" loading="lazy" class="rounded-box w-full object-cover h-64" />
          </div>
        }
      </div>

      @if (!atEnd && currentSlide < photos.length - 1) {
        <button
          (click)="goTo(currentSlide + 1)"
          class="btn btn-circle btn-ghost absolute right-2 top-1/2 -translate-y-1/2 z-20 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity bg-base-100/50">
          ❯
        </button>
      }
    </div>
  </div>
</div>
